module.exports = __webpack_public_path__ + "static/media/login-bg.77f532c7.png";